import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';
/**
 * Colunas da tabela de pedidos usando TanStack Table
 */

export const getBenificiosColumns = (handleEditar, handleExcluir) => [
  {
    id: 'Categoria',
    header: 'Categoria',
    accessorKey: 'Categoria',
    size: 40,
    enableSorting: true,
    cell: ({
      getValue
    }) => <TruncatedText value={getValue()} maxLength={200} />
  }, {
    id: 'Nome',
    header: 'Nome',
    accessorKey: 'Nome',
    size: 40,
    enableSorting: true,
    cell: ({
      getValue
    }) => <TruncatedText value={getValue()} maxLength={40} />
  }
];
